module.exports = __webpack_public_path__ + "img/2Z.7a6110e5.jpg";